import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";
import _omit from "lodash/omit";

var _createReducer;

import { createReducer } from 'redux-act';
import { addTempData, removeTempData, getSecurityQuestions, createTUCustomer, authenticateWithGoogle, authenticateWithApple } from "../actions";
import { AuthProviders, ThirdPartyAuthFailReasons } from "../constants";
import { AppleAuthErrors, GoogleAuthErrors } from "../constants/internal";
export var getLastThirdPartyAuthFailReason = function getLastThirdPartyAuthFailReason(payload) {
  var _payload$data, _payload$data$error, _payload$data$error$d, _payload$data2, _payload$data2$error, _payload$data2$error$, _payload$data3, _payload$data3$error, _payload$data3$error$;

  if (payload !== null && payload !== void 0 && (_payload$data = payload.data) !== null && _payload$data !== void 0 && (_payload$data$error = _payload$data.error) !== null && _payload$data$error !== void 0 && (_payload$data$error$d = _payload$data$error.data) !== null && _payload$data$error$d !== void 0 && _payload$data$error$d.requires_password) return ThirdPartyAuthFailReasons.REQUIRES_PASSWORD;
  if (payload !== null && payload !== void 0 && (_payload$data2 = payload.data) !== null && _payload$data2 !== void 0 && (_payload$data2$error = _payload$data2.error) !== null && _payload$data2$error !== void 0 && (_payload$data2$error$ = _payload$data2$error.data) !== null && _payload$data2$error$ !== void 0 && _payload$data2$error$.user_must_set_password) return ThirdPartyAuthFailReasons.USER_MUST_SET_PASSWORD;
  if (payload !== null && payload !== void 0 && (_payload$data3 = payload.data) !== null && _payload$data3 !== void 0 && (_payload$data3$error = _payload$data3.error) !== null && _payload$data3$error !== void 0 && (_payload$data3$error$ = _payload$data3$error.data) !== null && _payload$data3$error$ !== void 0 && _payload$data3$error$.provider_id_conflict) return ThirdPartyAuthFailReasons.PROVIDER_ID_CONFLICT; // `POPUP_CLOSED_BY_USER` is set internally when the apple modal is closed

  if ((payload === null || payload === void 0 ? void 0 : payload.error) === GoogleAuthErrors.POPUP_CLOSED_BY_USER || payload === AppleAuthErrors.POPUP_CLOSED_BY_USER) return ThirdPartyAuthFailReasons.POPUP_CLOSED_BY_USER;
  return ThirdPartyAuthFailReasons.OTHER;
};

var clearThirdPartyAuthFailState = function clearThirdPartyAuthFailState(state) {
  return _omit(state, ['lastThirdPartyAuthFailProvider', 'lastThirdPartyAuthFailReason', 'code', 'email']);
};

var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, addTempData, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
}), _defineProperty(_createReducer, removeTempData, function (state, key) {
  return _omit(state, key);
}), _defineProperty(_createReducer, getSecurityQuestions.success, function (state, questions) {
  return _objectSpread(_objectSpread({}, state), {}, {
    securityQuestions: questions
  });
}), _defineProperty(_createReducer, createTUCustomer.fail, function (state, payload) {
  var internal_message = payload.internal_message,
      _payload$blocking_ema = payload.blocking_emails,
      blocking_emails = _payload$blocking_ema === void 0 ? [] : _payload$blocking_ema;
  var hasDuplicateEmail = blocking_emails.length > 0 && internal_message === 'Active TU Enrollment already exists for SSN';
  return _objectSpread(_objectSpread({}, state), {}, {
    duplicateEmail: hasDuplicateEmail && _get(blocking_emails, '[0]')
  });
}), _defineProperty(_createReducer, authenticateWithGoogle.SUCCESS_TYPE, clearThirdPartyAuthFailState), _defineProperty(_createReducer, authenticateWithApple.SUCCESS_TYPE, clearThirdPartyAuthFailState), _defineProperty(_createReducer, authenticateWithGoogle.FAIL_TYPE, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    lastThirdPartyAuthFailProvider: AuthProviders.GOOGLE,
    lastThirdPartyAuthFailReason: getLastThirdPartyAuthFailReason(payload)
  });
}), _defineProperty(_createReducer, authenticateWithApple.FAIL_TYPE, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    lastThirdPartyAuthFailProvider: AuthProviders.APPLE,
    lastThirdPartyAuthFailReason: getLastThirdPartyAuthFailReason(payload),
    code: _get(payload, 'temp.code'),
    email: _get(payload, 'temp.email')
  });
}), _createReducer), {});
export default reducer;